import { render } from "./email-verification-token-request.vue?vue&type=template&id=768dc67c&scoped=true"
import script from "./email-verification-token-request.vue?vue&type=script&lang=js"
export * from "./email-verification-token-request.vue?vue&type=script&lang=js"

import "./email-verification-token-request.vue?vue&type=style&index=0&id=768dc67c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768dc67c"]])

export default __exports__